import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function AdultCareWorkerLevel2() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    Adult Care Worker Apprenticeship
                  </h2>
                  <p style={{ fontSize: '1.5rem', marginBottom: 0, opacity: 0.95, fontWeight: '600' }}>
                    Level 2
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Course Overview Section */}
        <section id="course-overview" style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Course Overview
                  </h3>
                  
                  <div className="mb-4 p-4" style={{
                    backgroundColor: '#fef3c7',
                    borderRadius: '12px',
                    borderLeft: '4px solid #f59e0b'
                  }}>
                    <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', fontStyle: 'italic' }}>
                      <strong>Important:</strong> You need to be employed to start an Apprenticeship; please include the full contact details of your employer within your application. If you are unable to secure employment, you could enrol on a full-time study programme and transfer to an Apprenticeship later.
                    </p>
                  </div>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    To work in care is to make a positive difference to someone's life when they are faced with physical, practical, social, emotional, or intellectual challenges. Working with people, feeling passionate about supporting and enabling them to live a more independent and fulfilling life is a rewarding and worthwhile job that provides excellent career opportunities.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    The Health and Social Care Apprenticeship Standard provides you with the knowledge and skills needed to work in a variety of health and social care settings; from helping people with a particular need to providing vital assistance to healthcare professionals in the care of patients.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '25px' }}>
                    This Apprenticeship is predominantly a work-based training programme designed around the needs of both employers and apprentices and attendance at either campus is one day per week.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    This apprenticeship standard is for frontline staff who support adults with care and support needs to achieve their personal goals and live as independently and safely as possible, enabling them to have control and choice in their lives. The structure and content of the apprenticeship are varied and determined by and relevant to the type of the service being provided and the person supported. Apprentices may work in residential or nursing homes, domiciliary care, day centres, a person's own home or some clinical healthcare settings.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Assessment Methods Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Assessment Methods
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    Level 2 Apprenticeship Standard Adult Care Worker is a competence-based qualification which is assessed by a portfolio of evidence. You will be measured against learning outcomes and assessment criteria described in each unit of the qualification. You must meet all the learning outcomes within the chosen units and meet the rules of combination to be able to be awarded the qualification. Most of the assessment will be work-based, using real experiences, written assessments and observations by a qualified assessor.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '20px' }}>
                    Modes of assessment include:
                  </h4>

                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <div className="p-3" style={{
                        backgroundColor: '#F5EBFA',
                        borderRadius: '12px',
                        borderLeft: '4px solid #7B3F9E',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <span style={{ fontSize: '1.5rem', marginRight: '15px' }}>👁️</span>
                        <span style={{ color: '#334155', fontSize: '1rem', fontWeight: '500' }}>Direct observation</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-3" style={{
                        backgroundColor: '#F5EBFA',
                        borderRadius: '12px',
                        borderLeft: '4px solid #7B3F9E',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <span style={{ fontSize: '1.5rem', marginRight: '15px' }}>💬</span>
                        <span style={{ color: '#334155', fontSize: '1rem', fontWeight: '500' }}>Oral questioning</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-3" style={{
                        backgroundColor: '#F5EBFA',
                        borderRadius: '12px',
                        borderLeft: '4px solid #7B3F9E',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <span style={{ fontSize: '1.5rem', marginRight: '15px' }}>📋</span>
                        <span style={{ color: '#334155', fontSize: '1rem', fontWeight: '500' }}>Case studies</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-3" style={{
                        backgroundColor: '#F5EBFA',
                        borderRadius: '12px',
                        borderLeft: '4px solid #7B3F9E',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <span style={{ fontSize: '1.5rem', marginRight: '15px' }}>📝</span>
                        <span style={{ color: '#334155', fontSize: '1rem', fontWeight: '500' }}>Assignments and projects</span>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="p-3" style={{
                        backgroundColor: '#F5EBFA',
                        borderRadius: '12px',
                        borderLeft: '4px solid #7B3F9E',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <span style={{ fontSize: '1.5rem', marginRight: '15px' }}>✅</span>
                        <span style={{ color: '#334155', fontSize: '1rem', fontWeight: '500' }}>End Point Assessment (EPA)</span>
                      </div>
                    </div>
                  </div>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    A synoptic End Point Assessment (EPA) will include two distinct components. Firstly, the completion of a situational judgement test answered through a multiple-choice exercise (but not necessarily undertaken as an online or computer-based test) and secondly, a professional discussion. To achieve your final certification, you must have completed and achieved all elements of the end point assessments in addition to the Care Certificate.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Progression Options Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '2rem', fontWeight: '700', marginBottom: '30px' }}>
                    Progression Options
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    This qualification allows you to learn, develop and demonstrate the skills and knowledge required for employment and/or career progression in healthcare and adult care settings. You can progress to the Level 3 Diploma in Adult Care or the Level 3 Diploma in Healthcare Support providing they are in an appropriate job role or Level 3 Apprenticeship Standard for Leader in Adult Care.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Course Details Table Section */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1.05rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '25px 30px', color: '#fff', fontWeight: '600', backgroundColor: '#0369a1', width: '35%' }}>
                            Course Title
                          </td>
                          <td style={{ padding: '25px 30px', color: '#334155' }}>
                            Adult Care Worker Apprenticeship Level 2
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default AdultCareWorkerLevel2;